import React from "react";
import Tag from "./Tag";
import { createUseStyles } from "react-jss";
import defaultStyles from "./TagsStyles";

const useDefaultStyles = createUseStyles(defaultStyles);

const MAX_TAGS = 5;

export default ({ tags, useStyles }) => {
  const styles = useStyles || useDefaultStyles();
  return (
    <div className={styles.tagsContainer}>
      {tags.slice(0, MAX_TAGS).map((tag, index) => (
        <Tag tagText={tag} key={index} styles={styles} />
      ))}
    </div>
  );
};
